<template>
  <div class="responsive gap-2 text-md p-2">
    <router-link
      class="text-center p-2 relative rounded-lg overflow-hidden"
      v-for="item in consideredFeatures.filter((x) =>
        searchFilter ? x.title.toLowerCase().includes(searchFilter.toLowerCase()) : true
      )"
      :key="item.title"
      :to="item.path"
    >
      <div class="mx-auto rounded-xl w-16 h-16 duration-300 mb-4">
        <!-- <v-icon name="MdBookmarkSharp" /> -->
        <img class="absolute w-16" :src="backgroundImage" alt="" />
        <img class="z-10 relative" v-if="item.isImage" :src="item.icon" alt="" />
        <v-icon
          v-else
          :icon="item.icon"
          class="text-5xl z-10 relative mx-auto pt-1"
          :class="item.forManager ? 'text-accent' : 'text-yellow-300'"
        />
        <!-- <img v-bind:src="item.icon" alt="placeholder" class="mx-auto" /> -->
      </div>
      <span>{{ item.title }}</span>
    </router-link>
  </div>
</template>

<style scoped>
  .responsive {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media (max-width: 420px) {
    .responsive {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
</style>

<script>
  import { users } from "@/states/user";

  export default {
    name: "FeatureItemsComp",
    props: {
      searchFilter: {
        type: String
      }
    },
    data() {
      return {
        backgroundImage:
          process.env.VUE_APP_BACKGROUND_IMAGE || "https://r2-cdn.app-syntegra.com/icons/icon_border.png",
        items: [
          {
            title: "Tracking Access",
            icon: "https://r2-cdn.app-syntegra.com/icons/tracking_access.png",
            isImage: true,
            path: "/dashboard/manager/tracking",
            forManager: true,
            needPermission: "explicitTrackingAccess"
          },
          {
            title: "Mulai Laporan Harian",
            icon: "https://r2-cdn.app-syntegra.com/icons/daily.png",
            isImage: true,
            description: "Mulai Laporan Harian",
            path: "/dashboard/report/daily/new",
            need: "report"
          },
          // {
          //   title: "Laporan Kebersihan",
          //   icon: "ph:clipboard-duotone",
          //   description: "Mulai Laporan Harian",
          //   path: "/dashboard/report/cleaning",
          //   forManager: true,
          //   needPermission: "readAttendance"
          // },
          {
            title: "Overtime",
            icon: "ph:calendar-dots-duotone",
            description: "Overtime",
            path: "/dashboard/overtime",
            // needPermission: "explicitNull"
            need: "overtime"
          },
          {
            title: "Ringkasan Laporan Harian",
            icon: "https://r2-cdn.app-syntegra.com/icons/daily_report.png",
            isImage: true,
            description: "Absensi karyawan.",
            path: "/dashboard/report/daily",
            need: "report"
          },
          {
            title: "Ringkasan Kehadiran",
            icon: "https://r2-cdn.app-syntegra.com/icons/attendance.png",
            isImage: true,
            description: "Absensi karyawan.",
            path: "/dashboard/attendance",
            need: "attendance"
          },
          {
            title: "Mulai Patroli",
            icon: "https://r2-cdn.app-syntegra.com/icons/patrol.png",
            isImage: true,
            description: "Patroli.",
            path: "/dashboard/report/patrol/new",
            need: "patrol"
          },
          {
            title: "Ringkasan Laporan Patroli",
            icon: "https://r2-cdn.app-syntegra.com/icons/patrol_report.png",
            isImage: true,
            description: "Absensi karyawan.",
            path: "/dashboard/report/patrol",
            need: "patrol"
          },
          {
            title: "Monitor Kehadiran",
            description: "Monitor Kehadiran",
            icon: "https://r2-cdn.app-syntegra.com/icons/attendance.png",
            isImage: true,
            path: "/dashboard/attendance/monitor",
            forManager: true,
            needPermission: "readAttendance"
          },
          {
            title: "Legalitas",
            icon: "ph:shield-duotone",
            description: "Monitor Kehadiran",
            path: "/dashboard/legal",
            forManager: true,
            needPermission: "explicitLegalJudge"
          },
          {
            title: "Slip Gaji",
            icon: "ph:invoice",
            description: "Generate slip gaji karyawan.",
            path: "/dashboard/payroll",
            need: "slip"
          }
        ],
        users: users
      };
    },
    computed: {
      consideredFeatures() {
        return this.items
          .filter((x) => !x.need || this.users.data?.occupationMenus?.includes(x.need))
          .filter((x) => !x.needPermission || this.users.data?.occupationPermission?.includes(x.needPermission));
      }
    }
  };
</script>
